import { render } from "./AddAlloy.vue?vue&type=template&id=f9c5fc6a"
import script from "./AddAlloy.vue?vue&type=script&lang=js"
export * from "./AddAlloy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__